export default __webpack_public_path__ + "static/media/WM0440.34I-43836_-26161_0.b27b7a20.jpg";